import React, {useEffect, useState, useMemo, useCallback, useContext} from 'react';
import {useTranslation} from "react-i18next";
import Link from "react-router-dom";

import axios from "../../../../axios-defaults";
import Aux from '../../../../hoc/Auxiliary';
import formatDate from "../../../Utils/Date/formatDate";
import TableContainer from '../Communications/Table/TableContainer';
import DateFormated from "../../../Utils/Date/Date";
import DateFilters, {DEFAULT_DATE, TODAY} from "../Tables/DateFilters";
import Spinner from "../../../UI/Spinner";
import SearchForm from "../../../UI/SearchForm/SearchForm";
import Sorter from "../../../UI/Toolbar/Sorter";
import SelectWrapper from "../../../Utils/Input/SelectWrapper";
import ModalMxo from "../../../UI/Modal";
import Alert from "../../../UI/Alerts/Alert";
import OrderDetails from "./OrderDetails";
import OrderRepeat from "./OrderRepeat";
import OrderStatusPopup from "../../../Order/OrderStatusPopup";
import OrderCancel from "./OrderCancel";
import {toast} from "react-toastify";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import UserContext from '../../../../context/user-context';
import {fireGTMDownloadFileEvent, fireGTMOrderingEvent} from "../../../Utils/GTM/GTMHelper";

const ordersHistory = (props) => {
    const {t, i18n} = useTranslation();
    const userContext = useContext(UserContext);
    const {
        title,
        typeLabel,
        component,
        startDate,
        endDate,
        subAccountCode,
        subaccount
    } = props;

    const [originalDatas, setOriginalDatas] = useState([]);
    const [orders, setOrders] = useState([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [loading, setLoading] = useState(0);

    const [sortField, setSortField] = useState('date');
    const [sortDirection, setSortDirection] = useState('DESC');
    const [sortTableField, setSortTableField] = useState('date');
    const [sortTableDirection, setSortTableDirection] = useState('DESC');

    const [showModal, setShowModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalTitle, setModalTitle] = useState(false);
    const [modalContent, setModalContent] = useState(false);
    const [hideFooter, setHideFooter] = useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const [footerContent, setFooterContent] = useState('');
    const [repeatSuccess, setRepeatSuccess] = useState(false);
	const [modalType, setModalType] = useState('');

    const descAccessor = ((i18n.language === 'fr') ? 'descriptionFr' : 'descriptionEn');

    useEffect(async () => {
        setLoading(true)
        await getOrders()
        setLoading(false)
    }, [startDate, endDate, props.dateFilterType]);

    const reloadOrdersAfterAction = async () => {
        setLoading(true)
        await getOrders();
        setLoading(false)
    }

    const getOrders = async () => {
        if (startDate === null || endDate === null) {
            return;
        }

        const currentStartDate = (startDate) ? startDate : DEFAULT_DATE;
        const currentEndDate = (endDate) ? endDate : formatDate(TODAY);

        await axios.get(`/subAccounts/deliveries?subAccountCode=${subAccountCode}&startDate=${currentStartDate}&endDate=${currentEndDate}`)
            .then(response => {
                if (response.data.succeeded) {
                    let ordersTemp = response.data.data;
                    if (props.dateFilterType === 'current_orders') {
                        history.replaceState(null, null, ' ');
                        let ordersFiltered = ordersTemp.filter((item) => item.statusCode.code !== "L");
                        ordersTemp = ordersFiltered
                    }
                    setOrders(ordersTemp)
                    setOriginalDatas(ordersTemp)
                    //console.log('[OrderHistory.js] : deliveries items',response.data.data)
                }
            }).catch(error => {
                console.log('[OrderHistory.js] : Orders ajax error in getOrders()', error.message)
            });
    }

    const getOrderDetails = (deliveryNumber) => {
        if (!deliveryNumber) return null;

        setModalLoading(true);
        setShowModal(true);
        setModalTitle(t('orders.details.title'));
        setBackDrop(true);
		setHideFooter(false);
        setFooterContent('');
		setModalType('orderDetails');
        axios.get(`/deliveries/delivery?deliveryNumber=${parseInt(deliveryNumber)}`)
            .then(response => {
                setModalLoading(false);
                //console.log('[OrdersHistory] getOrderDetails() details',response.data);

                if (response.data.succeeded) {
                    const orderDetails = response.data.data;
                    setModalContent(
                        <OrderDetails order={orderDetails} subaccount={subaccount}/>
                    );
                }
            }).catch(error => {
            setModalLoading(false);
            console.log('[OrderHistory.js] : Order ajax error in getOrderDetails()', error.message);
        });
    }

    const openCancelOrderPopup = (elem) => {
        setModalLoading(true);
        setShowModal(true);
        setModalTitle(t('orders.details.confirm'));
        setHideFooter(true);
        setBackDrop(true);
        setFooterContent('');
		setModalType('orderCancel');
        setModalContent(
            <OrderCancel data={elem} actionClose={handleCloseModal} actionConfirm={deleteConfirmation}/>
        );
        setModalLoading(false);
    }

    const getOrderStatus = async (deliveryNumber) => {
        if (!deliveryNumber) return null;

        setModalLoading(true);
        setShowModal(true);
        setModalTitle(t('orders.details.titlestatus'));
        setBackDrop(true);
        setFooterContent('');
		setHideFooter(false);
        let orderStatusHeader = "";
        let orderStatusLines = "";
        let orderStatusFollowUp = "";

        await axios.get(`/deliveries/delivery?deliveryNumber=${parseInt(deliveryNumber)}`)
            .then(response => {
                if (response.data.succeeded) {
                    orderStatusLines = response.data.data;
                }
            }).catch(error => {
                console.log('[OrderHistory.js] : /deliveries/delivery ajax error in getOrderStatus()', error.message);
            });

        await axios.get(`/deliveries/deliveryHeader?deliveryNumber=${parseInt(deliveryNumber)}`)
            .then(response => {
                if (response.data.succeeded) {
                    orderStatusHeader = response.data.data;
                }
            }).catch(error => {
                console.log('[OrderHistory.js] : /deliveries/deliveryHeader ajax error in getOrderStatus()', error.message);
            });

        await axios.get(`/deliveries/deliveryFollowUp?deliveryNumber=${parseInt(deliveryNumber)}`)
            .then(response => {
                if (response.data.succeeded) {
                    orderStatusFollowUp = response.data.data;
                }
            }).catch(error => {
                console.log('[OrderHistory.js] : /deliveries/deliveryFollowUp ajax error in getOrderStatus()', error.message);
            });

        setModalLoading(false);
		setModalType('orderStatus');
        setModalContent(<OrderStatusPopup header={orderStatusHeader} lines={orderStatusLines}
                                          followUp={orderStatusFollowUp} subaccount={subaccount}/>);

    }

    const repeatOrderPopup = async (deliveryNumber) => {
        if (!deliveryNumber) return null;
		fireGTMOrderingEvent('1_debute', {action: 'commander_a_nouveau', product: 'Empaqueté'});
        setModalLoading(true);
		setRepeatSuccess(false);
        setShowModal(true);
        setModalTitle(t('orders.repeat.title'));
        setHideFooter(true);

        setFooterContent(<div className="modal-actions d-flex justify-content-between">
            <div className="d-flex flex-wrap w-100 ">
                <div className="col-12 d-flex justify-content-end">
                    <button className="btn btn--outline btn--outline--black btn--fs-12 mr-4"
                            onClick={()=>{repeatSuccess ? handleCloseModal() : handleCloseModalOrderRepeat()}}>
                        {t("popuporderstatus.cancel.close")}
                    </button>
                    <button className="btn btn--raised btn--raised--red btn--fs-12" type="submit" id="repeat-sender"
                            form="repeatorderform"
                    >
                        {t("popuporderstatus.cancel.confirm")}
                    </button>
                </div>
            </div>
        </div>);
        setBackDrop('static');

        await Promise.all([axios.get(`subAccounts/onlineOrderDefaults?accountCode=${subaccount.accountCode}&subAccountCode=${subAccountCode}&deliveryMode=E&tankNumber=0`),
            axios.get(`/deliveries/delivery?deliveryNumber=${parseInt(deliveryNumber)}`)])
            .then((responses) => {
                setModalLoading(false);
                if (responses[0].data.succeeded && responses[1].data.succeeded) {
                    const orderOnlineDefault = responses[0].data.data;
                    const orderDetails = responses[1].data.data;
					setModalType('orderRepeat');
                    setModalContent(
                        <OrderRepeat order={orderDetails}
                                     orderDefault={orderOnlineDefault}
                                     confirm={false}
                                     subaccount={subaccount}
                                     actionConfirm={confirmRepeatAction}/>
                    );
                }
            });
    }

    const onSearchDataUpdate = (searchData) => {
        if (Array.isArray(searchData)) {
            return setOrders(searchData);
        } else {
            return null;
        }
    }

    const storeSortedItems = (sortedItems) => {
        if (sortedItems.length > 0) {
            setOrders(sortedItems);
        }
    }
    const handlePage = (pageIndex) => {
        setPageIndex(pageIndex);
    }

    const handleSort = useCallback(sortBy => {
        if (sortBy.length > 0) {
            setSortField(sortBy[0].id);
            setSortDirection(sortBy[0].desc ? 'DESC' : 'ASC')
        }
    }, [])

    const setSorterCallback = (columnId, direction) => {
        setSortTableField(columnId)
        setSortTableDirection(direction)
    }

    const setSortByCallback = useMemo(() =>
            [{desc: sortTableDirection === 'DESC', id: sortTableField}]
        , [sortTableDirection, sortTableField])

    const onClickDownload = (filename) => {
		fireGTMDownloadFileEvent('delproof', 'PDF')
        window.open(`/rest/v1/communications/download?filename=${encodeURI(filename)}`)
    }

	const handleCloseModalOrderRepeat = () => {
		setShowModal(false);
		fireGTMOrderingEvent('9_annule',{action: 'commander_a_nouveau', product : 'Empaqueté'});
	}
    const handleCloseModal = () => {
		setShowModal(false);
	}
    const handleShowModal = () => setShowModal(true);

    const deleteConfirmation = (cancelation) => {
        setLoading(true);
        axios.put(`orders/putOnlineOrderStatus`, cancelation)
            .then(response => {
                if (response.data) {
                    if (response.data.succeeded) {
                        toast.success(
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp; {t("popuporderstatus.cancel.updated")}
                            </div>
                        );
                    } else {
                        toast.error(
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp; {response.data.message}
                            </div>
                        );
                    }
                }

                reloadOrdersAfterAction();
                setLoading(false);
            }).catch(error => {
            console.log('[OrderHistory.js] : OrdersHistory ajax error in deleteConfirmation()', error.message)
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp; {t("popuporderstatus.cancel.error")}
                </div>
            );
            setLoading(false);
        });
        handleCloseModal();
    }

    const confirmRepeatAction = (event, order, subaccount, orderDefault) => {
        let total = parseInt(document.getElementById("total-qty").innerText);
        if (total > 0) {
            let objetsLines  = order.lines.map((item, index) => {
               return {
                   lineNumber : index,
                   productCode : item.productCode.code,
                   harnoisProductCode : item.harnoisProductCode.code,
                   tankNumber : 0,
                   fixedPrice : 0,
                   requestedQuantity : parseInt(document.getElementById(`product-${item.productCode.code}`).value),
                   isRequestedFull: false
               }
            })

            let lines = objetsLines;
            let formValues = {
                accountCode: subaccount.accountCode,
                subAccountCode: subaccount.subAccountCode,
                deliveryMode: "E",
                lines,
                purchaseOrderNumber: event.target.elements.ordernumber.value,
                deliveryNote: event.target.elements.note.value,
                orderInstruction: orderDefault.orderInstruction,
                customerNote: orderDefault.customerNote,
                organizationUnitCode: orderDefault.organizationUnitCode,
                orderPriority: orderDefault.orderPriority.code,
                orderOrigin: orderDefault.orderOrigin.code,
                deliveryDate: orderDefault.deliveryDate,
                orderedByEmail: userContext.user.infos.email
            }
			setModalType('orderRepeat');
            setModalContent(<Spinner/>);
            setFooterContent(null);
			axios.post(`/subAccounts/postOnlineOrder`, formValues)
                .then(response => {
                    if (response.data.succeeded) {
						fireGTMOrderingEvent('2_succes',{action: 'commander_a_nouveau', product : 'Empaqueté'});
						setRepeatSuccess(true);
						showRepeatSuccess(response.data,formValues,order,subaccount);
                    }
                    setLoading(false);
                }).catch(error => {
                console.log('[OrdersHistory.js] : Ajax error in confirmRepeatAction()', error.message);
				fireGTMOrderingEvent('9_echoue',{action: 'commander_a_nouveau', product : 'Empaqueté'});
				setRepeatSuccess(false);
                setModalContent(<p>{error.message}</p>)
            });
            //handleCloseModal();
        } else {
            alert( t('orders.history.nototal'));
        }

    }

    const showRepeatSuccess = (resp,formValues,orderDetails,subaccount) =>{
        setModalTitle(t('orders.history.orderconfirm'))
        setHideFooter(false);
        setFooterContent(null);
		setModalType('orderRepeat');
        setModalContent(<OrderRepeat order={orderDetails}
                                     subaccount={subaccount}
            response={resp} formValues={formValues} confirm={true} />)
    }

    const columns = useMemo(
        () => [
            {
                Header: t('orders.history.table.headers.requestnumber'),
                accessor: 'onlineOrderId',
                Cell: (props) => {
                    return (props.value) ? <strong>{props.value}</strong> : '';
                },
            },
            {
                Header: t('orders.history.table.headers.deliverynumber'),
                accessor: 'deliveryNumber',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.history.table.headers.deliverytype'),
                accessor: 'deliveryMode',
                Cell: (props) => {
                    return (props.value[descAccessor]) ? props.value[descAccessor] : '';
                },
            },
            {
                Header: t('orders.history.table.headers.ponumber'),
                accessor: 'poNumber',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },
            {
                Header: t('orders.history.table.headers.estdate'),
                accessor: 'deliveryDate',
                sort: 'desc',
                Cell: (props) => {
                    return (
                        <React.Fragment>
                            {(props.value) ?
                                <React.Fragment>
                                    <DateFormated date={props.value} withTime={false}/><br/>
                                </React.Fragment> : ''
                            }
                            <button className="link link--red link--underline"
                                    onClick={() => getOrderDetails(props.row.original.deliveryNumber)}>
                                {t('orders.history.table.orderdetailsbtn')}
                            </button>
                        </React.Fragment>
                    );
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1)
                        return 1;
                    else if (a1 > b1)
                        return -1;
                    else
                        return 0;
                }
            },
            {
                Header: t('orders.history.table.headers.origin'),
                accessor: 'orderOriginCode',
                Cell: (props) => {
                    return (props.value[descAccessor]) ? props.value[descAccessor] : '';
                }
            },
            {
                Header: t('orders.history.table.headers.status'),
                accessor: 'statusCode',
                Cell: (props) => {
                    const proofDocument = props.row.original.proofOfDeliveryDocument;
                    const transportManifest = props.row.original.transportManifestDocument;
                    return (
                        <div>
                            {props.value[descAccessor]}
                            {( proofDocument || transportManifest) && <div className="d-flex flex--justify-space-evenly">
                                {(proofDocument) ?
                                    <React.Fragment>
                                        <OverlayTrigger placement="top"
                                                        overlay={<Tooltip id="tooltip-top">
                                                            {t('orders.history.table.headers.proof')}
                                                        </Tooltip>}>
                                            <button className="btn-info-tooltip btn-info-tooltip--icon btn-info-tooltip--red" onClick={() => onClickDownload(proofDocument)}
                                            >
                                                <i className="mxo-custom-icon mxo-proof"></i>
                                            </button>
                                        </OverlayTrigger>
                                    </React.Fragment>
                                    : null
                                }
                                {(transportManifest) ?
                                    <React.Fragment>
                                        <OverlayTrigger placement="top"
                                                        overlay={<Tooltip id="tooltip-top">
                                                            {t('orders.history.table.headers.manifest')}
                                                        </Tooltip>}>
                                            <button className="btn-info-tooltip btn-info-tooltip--icon btn-info-tooltip--red" onClick={() => onClickDownload(transportManifest)}
                                            >
                                                <i className="mxo-custom-icon mxo-trucknote"></i>
                                            </button>
                                        </OverlayTrigger>

                                    </React.Fragment>
                                    : null
                                }

                            </div>}

                        </div>
                    );
                },
            }, {
                Header: '',
                accessor: 'actions',
                Cell: (props) => {
                    let row = props.row.original;
                    return (
                        <React.Fragment>
                            {row.isDeliveryCreated &&
                            <button className="link link--red link--fs-12 link--upper"
                                    onClick={() => getOrderStatus(row.deliveryNumber)}>
                                <strong>{t('orders.history.table.followorder')}&nbsp;&nbsp;<i
                                    className="fas fa-angle-right"></i></strong>
                            </button>}
                            {row.canShowCancelOrderButton && row.canCancel &&
                            <React.Fragment>
                                {row.isDeliveryCreated && <br/>}
                                <button className="link link--fs-12 link--upper link--red"
                                        onClick={() => openCancelOrderPopup(row)}>
                                    <strong>{t('orders.history.table.cancelorder')}&nbsp;&nbsp;<i
                                        className="far fa-times"></i></strong>
                                </button>
                            </React.Fragment>
                            }
                            {row.canShowCancelOrderButton && !row.canCancel &&
                            <React.Fragment>
                                {row.isDeliveryCreated && <br/>}
                                <OverlayTrigger placement='bottom'
                                                overlay={<Tooltip id="tooltip-right">
                                                    {t('orders.history.table.cancelhelp')}
                                                </Tooltip>}>
                                    <button
                                        className={`link link--fs-12 link--upper ${(row.canCancel) ? "link--red" : "link--disabled"}`}>
                                        <strong>{t('orders.history.table.cancelorder')}&nbsp;&nbsp;<i
                                            className="far fa-times"></i></strong>
                                    </button>
                                </OverlayTrigger>
                            </React.Fragment>
                            }
                            {(row.statusCode.code === "L" || row.orderStatus.code === "U") && row.deliveryMode.code === "E" &&
                                !row.isNegativeDelivery ?
                                <React.Fragment>
                                    <br/>
                                    <button className="link link--black link--fs-12 link--upper a-left"
                                            onClick={() => repeatOrderPopup(row.deliveryNumber)}>
                                        <strong>{t('orders.history.table.repeat', {space: '\u00A0'})}&nbsp;&nbsp;<i
                                            className="fas fa-angle-right"></i></strong>
                                    </button>
                                </React.Fragment> : ''}
                        </React.Fragment>
                    );
                }
            },
        ],
        [t, i18n, orders]
    );

    return (
        <Aux>
            <h2 className="headline headline--section headline--uppercase">{title}</h2>
            <SearchForm data={originalDatas} currentData={orders} updateData={onSearchDataUpdate}/><br/>
            <DateFilters
                startDate={props.startDate}
                endDate={props.endDate}
                setStartDate={props.setStartDate}
                setEndDate={props.setEndDate}
                changeDateFilterType={props.changeDateFilterType}
                dateFilterType={props.dateFilterType}
                enableCurrentOrders={true}
                component={component}
            />
            {(loading)
                ? <Spinner/>
                : (<Aux>
                        <h3 className="headline headline--block mt-4">{orders.length} {t('orders.history.orders')}</h3>
                        {originalDatas.length !== 0 ? <Aux>
                            <div className="row datatable__filters">
                                <div className="col-lg-12 col-md-12 filters__right">
                                    <Sorter
                                        sortOptions={[
                                            {
                                                label: t('orders.history.table.headers.requestnumber'),
                                                id: 'onlineOrderId',
                                                value: 'onlineOrderId',
                                                type: 'int'
                                            }, {
                                                label: t('orders.history.table.headers.deliverynumber'),
                                                id: 'deliveryNumber',
                                                value: 'deliveryNumber',
                                                type: 'int'
                                            }, {
                                                label: t('orders.history.table.headers.deliverytype'),
                                                id: 'deliveryMode',
                                                value: 'deliveryMode.code',
                                                type: 'string'
                                            }, {
                                                label: t('orders.history.table.headers.ponumber'),
                                                id: 'poNumber',
                                                value: 'poNumber',
                                                type: 'string'
                                            }, {
                                                label: t('orders.history.table.headers.estdate'),
                                                id: 'deliveryDate',
                                                value: 'deliveryDate',
                                                type: 'date'
                                            }, {
                                                label: t('orders.history.table.headers.origin'),
                                                id: 'orderOriginCode',
                                                value: 'orderOriginCode.code',
                                                type: 'String'
                                            }, {
                                                label: t('orders.history.table.headers.status'),
                                                id: 'statusCode',
                                                value: 'orderStatus.code',
                                                type: 'String'
                                            },
                                        ]}
                                        items={orders}
                                        getSortedItems={storeSortedItems}
                                        setSortByCallback={setSorterCallback}
                                        sortDirection={sortDirection}
                                        sortField={sortField}
                                    />
                                </div>

                            </div>
                            <TableContainer
                                columns={columns}
                                data={orders}
                                typeLabel={typeLabel}
                                onPage={handlePage}
                                onSort={handleSort}
                                setSortByCallback={setSortByCallback}
                                initialPageIndex={pageIndex}/>
                            <ModalMxo title={modalTitle}
                                      show={showModal}
                                      hideFooter={hideFooter}
                                      footerActions={footerContent}
                                      backDrop={backDrop}
                                      onHide={()=>{modalType === 'orderRepeat' && !repeatSuccess ? handleCloseModalOrderRepeat() : handleCloseModal()}}
                                      onShow={handleShowModal}>
                                {modalLoading ? <Spinner/> : modalContent}
                            </ModalMxo>
                        </Aux> : ''}

                    </Aux>

                )
            }
        </Aux>
    );
};
export default ordersHistory;
